import React from "react";
import { BiSolidCategoryAlt, BiSolidDonateBlood } from "react-icons/bi";
import { FaDatabase, FaHome, FaImages, FaUser } from "react-icons/fa";
import { IoIosLink, IoMdNotifications } from "react-icons/io";
import { IoVideocam } from "react-icons/io5";
import { RiAdvertisementFill, RiUserCommunityFill } from "react-icons/ri";

export const menuItems = [
  {
    path: "/",
    icon: <FaHome className="text-xl" />,
    label: "DASHBOARD",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/users",
    icon: <FaUser className="text-xl" />,
    label: "USER (યુઝર)",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/category",
    icon: <BiSolidCategoryAlt className="text-xl" />,
    label: "Post Category (પોસ્ટ કેટેગરી)",
    roles: ["admin"],
  },
  {
    path: "/category-data",
    icon: <FaDatabase className="text-xl" />,
    label: "Post Data (પોસ્ટ ડેટા)",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/bloodGroup",
    icon: <BiSolidDonateBlood className="text-xl" />,
    label: "BloodGroup (બ્લડગ્રુપ)",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/gallery-category",
    icon: <FaImages className="text-xl" />,
    label: "Images (ગેલેરી)",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/video-category",
    icon: <IoVideocam className="text-xl" />,
    label: "Video-Url (વિડિઓ)",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/notification",
    icon: <IoMdNotifications className="text-xl" />,
    label: "Notification (નોટિફિકેશન)",
    roles: ["admin"],
  },
  {
    path: "/community",
    icon: <RiUserCommunityFill className="text-xl" />,
    label: "Commity (કમિટી)",
    roles: ["admin", "subadmin"],
  },
  // {
  //   path: "/commity-member",
  //   icon: <FaUsers className="text-xl" />,
  //   label: "Commity-Member",
  //   roles: ["admin", "subadmin"],
  // },
  {
    path: "/donor-category",
    icon: <RiUserCommunityFill className="text-xl" />,
    label: "Donor (દાતા)",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/customer-request",
    icon: <RiUserCommunityFill className="text-xl" />,
    label: "Suggestions (સૂચનો)",
    roles: ["admin"],
  },
  // {
  //   path: "/donor-member",
  //   icon: <FaUsers className="text-xl" />,
  //   label: "Donor-Member",
  //   roles: ["admin", "subadmin"],
  // },
  {
    path: "/advertisement",
    icon: <RiAdvertisementFill className="text-xl" />,
    label: "Advertisement (જાહેરાત)",
    roles: ["admin", "subadmin"],
  },
  // {
  //   path: "/result-category",
  //   icon: <BiSolidCategory className="text-xl" />,
  //   label: "Result-Category",
  //   roles: ["admin", "subadmin"],
  // },
  // {
  //   path: "/results",
  //   icon: <TbCardsFilled className="text-xl" />,
  //   label: "Result-Upload",
  //   roles: ["admin", "subadmin"],
  // },
  {
    path: "/new-registration",
    icon: <FaUser className="text-xl" />,
    label: "New Registration (નવી નોંધણી)",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/user-registration-link",
    icon: <IoIosLink className="text-xl" />,
    label: "Registration Link (નોંધણી લિંક)",
    roles: ["admin", "subadmin"],
  },
];
